import { useContext, useEffect } from "react";
import "./App.css";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { SocketProvider, SocketContext } from "./context/SocketContext";
import { CallPopupProvider } from "./context/CallPopupContext";
import axiosInstance from "./routes/axiosInstance";

import ChatListPage from "./pages/ChatListPage";
import CallListPage from "./pages/CallListPage";
import EditChatPage from "./pages/EditChatPage";
import ConversationPage from "./pages/ConversationPage";
import NewChatPage from "./pages/NewChatPage";
import NewGroupChatPage from "./pages/NewGroupChatPage";
import SettingPage from "./pages/SettingPage";
// import VideoCallPage from "./pages/VideoCallPage";
// import AudioCallPage from "./pages/AudioCallPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import NotfoundPage from "./pages/NotfoundPage";
// import CallPopup from "./pages/CallPopup";
import VideoCallPopup from "./pages/VideoCallPopup";
// import CallWidget from "./pages/CallWidget";
import CreateSpacePage from "./pages/CreateSpacePage";
import SpaceListPage from "./pages/SpaceListPage";
import EditSpacePage from "./pages/EditSpacePage";

import ProtectedRoute from "./routes/ProtectedRoutes";

// public pages no auth required
import LoginPage from "./pages/public/LoginPage";
import SignupPage from "./pages/public/SignupPage";
import LandingPage from "./pages/public/LandingPage";
import PricingPage from "./pages/public/PricingPage";
import FeaturesPage from "./pages/public/FeaturesPage";
import SpacePage from "./pages/public/SpacePage";
import SpacePreviewPage from "./pages/public/SpacePreviewPage";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  // Define public path patterns (regex)
  const publicPathPatterns = [
    /^\/$/,
    /^\/pricing$/,
    /^\/features$/,
    /^\/login$/,
    /^\/signup$/,
  ];

  const publicAndPrivatePathPatterns = [
    /^\/space\/[^/]+\/[^/]+$/, // /space/:referenceId/:spaceNameSlug
    /^\/s\/[^/]+\/[^/]+$/, // /s/:referenceId/:spaceNameSlug
  ];

  // Function to check if current path matches any public pattern
  const isPublicPath = publicPathPatterns.some((pattern) =>
    pattern.test(location.pathname),
  );

  // Function to check if current path matches any public pattern
  const isGlobalPath = publicAndPrivatePathPatterns.some((pattern) =>
    pattern.test(location.pathname),
  );

  const userSessionCheck = async () => {
    let currentUser;
    const storedUser = localStorage.getItem("current-user");
    if (storedUser && JSON.parse(storedUser)) {
      currentUser = JSON.parse(storedUser);
    }

    try {
      const headers = currentUser?.token
        ? { Authorization: `Bearer ${currentUser.token}` }
        : {};

      const res = await axiosInstance.get("/api/validate-session", {
        headers,
      });

      if (res.status === 200) {
        if (isPublicPath) {
          navigate("/chats");
        }
      }
    } catch (error) {
      console.error("Session expired or invalid.");
      if (error.status === 401) {
        localStorage.removeItem("current-user");
        localStorage.removeItem("callData");
        localStorage.removeItem("vv-call-data");
        if (isGlobalPath) {
          // be on same page
        } else if (!isPublicPath) {
          navigate("/");
        }
      } else if (error.status === 409) {
        navigate("/verify-email");
      }
    }
  };

  useEffect(() => {
    userSessionCheck();
  }, []);

  const RoutesContent = () => {
    const { socketConnected } = useContext(SocketContext);

    return (
      <>
        {socketConnected && <VideoCallPopup />}
        {/* {socketConnected && <CallPopup />} */}
        {/* {socketConnected && <CallWidget />} */}
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route
            path="/space/:referenceId/:spaceNameSlug"
            element={<SpacePage />}
          />
          <Route
            path="/s/:referenceId/:spaceNameSlug"
            element={<SpacePreviewPage />}
          />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route
            path="/verify-email"
            element={
              <ProtectedRoute>
                <VerifyEmailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chats"
            element={
              <ProtectedRoute>
                <ChatListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/calls"
            element={
              <ProtectedRoute>
                <CallListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chats/:chatId/edit"
            element={
              <ProtectedRoute>
                <EditChatPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chats/:chatId/messages"
            element={
              <ProtectedRoute>
                <ConversationPage />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/call/:chatId/video"
            element={
              <ProtectedRoute>
                <VideoCallPage />
              </ProtectedRoute>
            }
          /> */}
          {/* <Route
            path="/call/:chatId/audio"
            element={
              <ProtectedRoute>
                <AudioCallPage />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/chats/new"
            element={
              <ProtectedRoute>
                <NewChatPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chats/group/new"
            element={
              <ProtectedRoute>
                <NewGroupChatPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/spaces/new"
            element={
              <ProtectedRoute>
                <CreateSpacePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/spaces"
            element={
              <ProtectedRoute>
                <SpaceListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/space/:spaceId/edit"
            element={
              <ProtectedRoute>
                <EditSpacePage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotfoundPage />} />
        </Routes>
      </>
    );
  };

  return (
    <div className="App" bg="gray.50">
      <AuthProvider>
        <SocketProvider>
          <CallPopupProvider>
            <RoutesContent />
          </CallPopupProvider>
        </SocketProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
